import inView from 'in-view';

export function reveal($selectors, revealOptions) {
  if (Object.prototype.toString.call($selectors) === '[object String]') {
    $selectors = $($selectors);
  }

  const defaultOptions = {
    delay: 350,
    interval: 0,
  };

  const options = { ...defaultOptions, ...revealOptions };

  let intervalIndex = 0;

  $selectors.each(function () {
    const id =
      $(this).attr('id') ||
      `in-view-${Math.random().toString(36).substr(2, 9)}`;
    $(this).attr('id', id);

    const selector = `#${id}`;

    /*
     * Animation delay and interval
     */
    inView(selector).once('enter', function (el) {
      let interval = 0;
      let { delay } = options;

      if (options.interval) {
        interval = intervalIndex * 200;
        delay += interval;
        intervalIndex += 1;
        setTimeout(function () {
          intervalIndex -= 1;
        }, delay);
      }

      $(selector).addClass('revealed');
      $(selector).css('--transition-delay', `${delay}ms`);
    });
  });
}

export function undoReveal($selectors) {
  if (Object.prototype.toString.call($selectors) === '[object String]') {
    $selectors = $($selectors);
  }

  $selectors.removeAttr('id');
  $selectors.removeClass('revealed');
}
